import React, { useState, useEffect } from "react";
import { FaUserCircle, FaSearch, FaTimes, FaBars, FaPlus, FaBriefcase, FaHome, FaCog, FaBell, FaChevronDown } from "react-icons/fa";
import { bookizapLogo } from "../../Assets/Icons/IconsIndex";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PreLoginHeader from "./PreLoginHeader/PreLoginHeader";

// Premium logo for demonstration
const headerLogo = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2'%3E%3Cpath d='M12 2L2 7l10 5 10-5-10-5z'/%3E%3Cpath d='M2 17l10 5 10-5'/%3E%3Cpath d='M2 12l10 5 10-5'/%3E%3C/svg%3E";

const Header = () => {
  const navigate =useNavigate();
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchFocused, setSearchFocused] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const isAuthenticated = useSelector((state) => state.login.isAuthenticated);
  const profileInfo = useSelector((state) => state.login.userData);
  // Mock data for demonstration

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when screen size changes
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleUserDropdown = () => setUserDropdownOpen(!userDropdownOpen);
  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);

  const handleLogin = () => {
  };

 

  const handleCreateJob = () => {
    navigate("/createJob")
    setMobileMenuOpen(false);
  };

  const handleLogout = () => {
    setUserDropdownOpen(false);
    setMobileMenuOpen(false);
  };

  const handleNavigation = (path) => {
    setMobileMenuOpen(false);
  };

    const profileHandler = () => {
    navigate("/profile");
  };

  return (
    <>
    {isAuthenticated ?(
      
      <>
      {/* Premium White Header */}
      <header className="fixed top-0 left-0 right-0 z-50 transition-all bg-white " >
        
        {/* Premium subtle gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-blue-50/30 via-purple-50/20 to-blue-50/30"></div>
        
        <div className="relative w-full max-w-8xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="flex items-center justify-between h-20 sm:h-22 lg:h-24">
            
            {/* Premium Logo Section */}
            <div className="flex-shrink-0">
              <a href="/" className="flex items-center group">
                <div className="relative">
                  {/* Logo background with premium effect */}
                  <div className="absolute -inset-3 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-all duration-500 blur-lg"></div>
                  <div className="">
                    <img 
                      src={bookizapLogo} 
                      className="h-10 sm:h-12 lg:h-14 transition-all duration-500" 
                      alt="Logo" 
                    />
                  </div>
                </div>
                <div className="ml-4 hidden sm:block">
                  <h1 className="text-xl lg:text-2xl font-bold bg-gradient-to-r from-gray-800 via-gray-900 to-gray-800 bg-clip-text text-transparent">
                    Bookizap
                  </h1>
                  {/* <p className="text-xs text-gray-500 font-medium tracking-wide">
                    Premium Careers
                  </p> */}
                </div>
              </a>
            </div>

            {/* Premium Desktop Search Bar */}
            <div className="hidden lg:flex flex-1 max-w-2xl mx-8 xl:mx-12">
              <div className={`relative w-full transition-all duration-500 ${
                searchFocused ? 'transform scale-[1.02]' : ''
              }`}>
                <div className="absolute -inset-1 bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur"></div>
                <div className="relative">
                  <input
                    className={`w-full pl-14 pr-16 py-4 bg-gray-50/50 backdrop-blur-sm border-2 rounded-2xl text-base text-gray-800 placeholder-gray-500 transition-all duration-500 focus:outline-none focus:bg-white focus:border-blue-400/60 focus:shadow-2xl focus:shadow-blue-500/10 ${
                      searchFocused ? 'shadow-2xl border-blue-400/40 bg-white shadow-blue-500/5' : 'border-gray-200/50 hover:border-gray-300/70 hover:bg-white/80'
                    }`}
                    placeholder="Search Jobs or Zap Heros..."
                    onFocus={() => setSearchFocused(true)}
                    onBlur={() => setSearchFocused(false)}
                  />
                  <div className={`absolute left-5 top-1/2 transform -translate-y-1/2 transition-all duration-300 ${
                    searchFocused ? 'text-blue-500 scale-110' : 'text-gray-400'
                  }`}>
                    <FaSearch className="text-lg" />
                  </div>
                  <div className="absolute right-4 top-1/2 transform -translate-y-1/2 flex items-center space-x-2">
                    <kbd className="px-3 py-1.5 text-sm font-semibold text-gray-600 bg-gray-100/80 border border-gray-200/60 rounded-lg backdrop-blur-sm shadow-sm">
                      search
                    </kbd>
                  </div>
                </div>
              </div>
            </div>

            {/* Premium Desktop Actions */}
            <div className="hidden lg:flex items-center space-x-4">
              
              {/* Notifications */}
              <button className="relative p-3 rounded-xl bg-gray-50/60 hover:bg-gray-100/80 border border-gray-200/40 hover:border-gray-300/60 transition-all duration-300 group shadow-sm hover:shadow-md">
                <FaBell className="text-gray-600 group-hover:text-gray-800 text-lg" />
                <span className="absolute -top-1 -right-1 w-3 h-3 bg-gradient-to-r from-red-500 to-pink-500 rounded-full ring-2 ring-white shadow-sm"></span>
              </button>
              
              {/* Premium Create Job Button */}
              <button
                onClick={handleCreateJob}
                className="relative flex items-center space-x-1 px-8 py-3 bg-gradient-to-r from-blue-600 via-blue-500 to-purple-600 text-white rounded-2xl text-base font-semibold transition-all duration-500 hover:from-blue-700 hover:via-blue-600 hover:to-purple-700 hover:shadow-2xl hover:shadow-blue-500/25 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500/40 focus:ring-offset-2 focus:ring-offset-white group overflow-hidden shadow-xl"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                <FaPlus className="text-sm relative z-10" />
                <span className="relative z-10">Create Job</span>
              </button>

              {/* Premium User Section */}
              {isAuthenticated ? (
                <div className="relative">
                  <button
                    onClick={profileHandler}
                    className="flex items-center space-x-4 px-5 py-3 rounded-2xl bg-gray-50/60 hover:bg-gray-100/80 border border-gray-200/40 hover:border-gray-300/60 transition-all duration-300 group shadow-sm hover:shadow-lg"
                  >
                    {profileInfo?.profilePicture ? (
                      <img
                        src={profileInfo.profilePicture}
                        alt="Profile"
                        className="w-10 h-10 rounded-full object-cover ring-2 ring-gray-200 group-hover:ring-gray-300 shadow-md"
                      />
                    ) : (
                      <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 flex items-center justify-center ring-2 ring-gray-200 group-hover:ring-gray-300 shadow-md">
                        <FaUserCircle className="text-white text-lg" />
                      </div>
                    )}
                    <div className="text-left">
                      <span className="block font-semibold text-base text-gray-800 group-hover:text-gray-900 capitalize">
                        {profileInfo?.firstName || "Profile"}
                      </span>
                    </div>
                    {/* <FaChevronDown className={`text-gray-500 group-hover:text-gray-700 text-sm transition-transform duration-300 ${
                      userDropdownOpen ? 'rotate-180' : ''
                    }`} /> */}
                  </button>

                  {/* Premium Desktop User Dropdown */}
                  {/* {userDropdownOpen && (
                    <div className="absolute right-0 mt-3 w-72 bg-white/98 backdrop-blur-2xl rounded-2xl shadow-2xl shadow-gray-200/60 border border-gray-200/60 py-3 animate-in slide-in-from-top-2 duration-300">
                      <div className="px-6 py-4 border-b border-gray-100/60">
                        <div className="flex items-center space-x-4">
                          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 flex items-center justify-center shadow-lg">
                            <FaUserCircle className="text-white text-xl" />
                          </div>
                          <div>
                            <p className="text-base font-semibold text-gray-900 capitalize">
                              {profileInfo?.firstName} {profileInfo?.lastName}
                            </p>
                            <p className="text-sm text-gray-600 truncate">
                              {profileInfo?.email}
                            </p>
                            <p className="text-xs text-blue-600 font-semibold">
                              Premium Member
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="py-2">
                        <button
                          onClick={profileHandler}
                          className="w-full px-6 py-3 text-left text-sm text-gray-700 hover:bg-gray-50/80 hover:text-gray-900 transition-all duration-200 flex items-center space-x-3"
                        >
                          <FaUserCircle className="text-lg text-gray-500" />
                          <span>View Profile</span>
                        </button>
                        <button
                          onClick={() => handleNavigation('dashboard')}
                          className="w-full px-6 py-3 text-left text-sm text-gray-700 hover:bg-gray-50/80 hover:text-gray-900 transition-all duration-200 flex items-center space-x-3"
                        >
                          <FaBriefcase className="text-lg text-gray-500" />
                          <span>Dashboard</span>
                        </button>
                        <button
                          onClick={() => handleNavigation('settings')}
                          className="w-full px-6 py-3 text-left text-sm text-gray-700 hover:bg-gray-50/80 hover:text-gray-900 transition-all duration-200 flex items-center space-x-3"
                        >
                          <FaCog className="text-lg text-gray-500" />
                          <span>Settings</span>
                        </button>
                      </div>
                      <hr className="my-2 border-gray-100/60" />
                      <button
                        onClick={handleLogout}
                        className="w-full px-6 py-3 text-left text-sm text-red-600 hover:bg-red-50/80 hover:text-red-700 transition-all duration-200"
                      >
                        Sign Out
                      </button>
                    </div>
                  )} */}
                </div>
              ) : (
                <button
                  onClick={handleLogin}
                  className="flex items-center space-x-3 px-8 py-4 border-2 border-gray-300/60 text-gray-700 rounded-2xl text-base font-semibold transition-all duration-300 hover:border-blue-400/60 hover:text-blue-700 hover:bg-blue-50/50 hover:shadow-lg shadow-sm"
                >
                  <FaUserCircle className="text-xl" />
                  <span>Sign In</span>
                </button>
              )}
            </div>

            {/* Premium Mobile/Tablet Actions */}
            <div className="flex lg:hidden items-center space-x-3">
              {/* Mobile Search Button */}
              <button 
                className="p-3 rounded-xl bg-gray-50/60 hover:bg-gray-100/80 border border-gray-200/40 transition-all duration-300 shadow-sm"
              >
                <FaSearch className="text-gray-600 text-lg" />
              </button>
              
              {/* Premium Hamburger Menu Button */}
              <button
                onClick={toggleMobileMenu}
                className="p-3 rounded-xl bg-gray-50/60 hover:bg-gray-100/80 border border-gray-200/40 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500/40 shadow-sm"
                aria-label="Toggle menu"
              >
                {mobileMenuOpen ? (
                  <FaTimes className="text-gray-600 text-lg" />
                ) : (
                  <FaBars className="text-gray-600 text-lg" />
                )}
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Premium Mobile/Tablet Menu Overlay */}
      {mobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40 lg:hidden transition-all duration-500"
          onClick={toggleMobileMenu}
        />
      )}

      {/* Premium Mobile/Tablet Slide-out Menu */}
      <div className={`fixed top-0 right-0 h-full w-96 max-w-[90vw] bg-white/98 backdrop-blur-2xl shadow-2xl shadow-gray-200/60 z-50 lg:hidden transform transition-all duration-500 ease-out border-l border-gray-200/60 ${
        mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
      }`}>
        <div className="flex flex-col h-full">
          
          {/* Premium Mobile Menu Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-200/40 bg-gradient-to-r from-gray-50/50 to-gray-100/30">
            <div>
              <h2 className="text-xl font-bold text-gray-900">Menu</h2>
              <p className="text-sm text-gray-600">Premium Access</p>
            </div>
            <button
              onClick={toggleMobileMenu}
              className="p-3 rounded-xl hover:bg-gray-100/60 transition-all duration-300"
              aria-label="Close menu"
            >
              <FaTimes className="text-gray-500 text-lg" />
            </button>
          </div>

          {/* Premium Mobile Search */}
          <div className="p-6 border-b border-gray-100/40">
            <div className="relative">
              <input
                className="w-full pl-12 pr-4 py-4 bg-gray-50/60 border border-gray-200/40 rounded-xl text-gray-800 placeholder-gray-500 focus:outline-none focus:border-blue-400/60 focus:bg-white transition-all duration-300 shadow-sm focus:shadow-lg"
                placeholder="Search opportunities..."
              />
              <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500 text-lg" />
            </div>
          </div>

          {/* Premium Mobile Menu Content */}
          <div className="flex-1 overflow-y-auto">
            <div className="p-6 space-y-6">
              
              {/* Premium Create Job Button */}
              <button
                onClick={handleCreateJob}
                className="w-full flex items-center justify-center space-x-4 px-8 py-5 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-2xl font-bold text-lg transition-all duration-300 hover:from-blue-700 hover:to-purple-700 shadow-xl hover:shadow-2xl hover:shadow-blue-500/20"
              >
                <FaPlus className="text-xl" />
                <span>Create Job</span>
              </button>

              {/* Premium Navigation Links */}
              <div className="space-y-3">
                <button
                  onClick={() => handleNavigation('home')}
                  className="w-full flex items-center space-x-4 px-5 py-4 text-gray-700 hover:bg-gray-50/80 hover:text-gray-900 rounded-xl transition-all duration-300 shadow-sm hover:shadow-md"
                >
                  <FaHome className="text-xl text-gray-500" />
                  <span className="font-semibold text-lg">Home</span>
                </button>
                <button
                  onClick={() => handleNavigation('jobs')}
                  className="w-full flex items-center space-x-4 px-5 py-4 text-gray-700 hover:bg-gray-50/80 hover:text-gray-900 rounded-xl transition-all duration-300 shadow-sm hover:shadow-md"
                >
                  <FaBriefcase className="text-xl text-gray-500" />
                  <span className="font-semibold text-lg">Jobs</span>
                </button>
              </div>

              {/* Premium User Section */}
              {isAuthenticated ? (
                <div className="mt-8 space-y-6">
                  <div className="flex items-center space-x-4 p-5 bg-gradient-to-r from-gray-50/60 to-gray-100/40 rounded-2xl border border-gray-200/40 shadow-sm">
                    {profileInfo?.profilePicture ? (
                      <img
                        src={profileInfo.profilePicture}
                        alt="Profile"
                        className="w-16 h-16 rounded-full object-cover ring-2 ring-gray-200 shadow-lg"
                      />
                    ) : (
                      <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 flex items-center justify-center shadow-lg">
                        <FaUserCircle className="text-white text-2xl" />
                      </div>
                    )}
                    <div className="flex-1 min-w-0">
                      <p className="font-bold text-gray-900 text-lg capitalize truncate">
                        {profileInfo?.firstName} {profileInfo?.lastName}
                      </p>
                      <p className="text-sm text-gray-600 truncate">
                        {profileInfo?.email}
                      </p>
                      <p className="text-xs text-blue-600 font-semibold">
                        Premium Member
                      </p>
                    </div>
                  </div>
                  
                  <div className="space-y-3">
                    <button
                      onClick={profileHandler}
                      className="w-full flex items-center space-x-4 px-5 py-4 text-gray-700 hover:bg-gray-50/80 hover:text-gray-900 rounded-xl transition-all duration-300 shadow-sm hover:shadow-md"
                    >
                      <FaUserCircle className="text-xl text-gray-500" />
                      <span className="font-semibold text-lg">View Profile</span>
                    </button>
                    <button
                      onClick={() => handleNavigation('dashboard')}
                      className="w-full flex items-center space-x-4 px-5 py-4 text-gray-700 hover:bg-gray-50/80 hover:text-gray-900 rounded-xl transition-all duration-300 shadow-sm hover:shadow-md"
                    >
                      <FaBriefcase className="text-xl text-gray-500" />
                      <span className="font-semibold text-lg">Dashboard</span>
                    </button>
                    <button
                      onClick={() => handleNavigation('settings')}
                      className="w-full flex items-center space-x-4 px-5 py-4 text-gray-700 hover:bg-gray-50/80 hover:text-gray-900 rounded-xl transition-all duration-300 shadow-sm hover:shadow-md"
                    >
                      <FaCog className="text-xl text-gray-500" />
                      <span className="font-semibold text-lg">Settings</span>
                    </button>
                  </div>
                </div>
              ) : (
                <div className="mt-8">
                  <button
                    onClick={handleLogin}
                    className="w-full flex items-center justify-center space-x-4 px-8 py-5 border-2 border-gray-300/60 text-gray-700 rounded-2xl font-bold text-lg transition-all duration-300 hover:border-blue-400/60 hover:text-blue-700 hover:bg-blue-50/50 shadow-sm hover:shadow-lg"
                  >
                    <FaUserCircle className="text-2xl" />
                    <span>Sign In</span>
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Premium Mobile Menu Footer */}
          {isAuthenticated && (
            <div className="p-6 border-t border-gray-200/40 bg-gradient-to-r from-gray-50/30 to-gray-100/20">
              <button
                onClick={handleLogout}
                className="w-full px-8 py-4 text-red-600 hover:bg-red-50/80 hover:text-red-700 rounded-xl transition-all duration-300 font-semibold text-lg shadow-sm hover:shadow-md"
              >
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Backdrop for dropdown (mobile only) */}
      {userDropdownOpen && (
        <div 
          className="fixed inset-0 z-30 lg:hidden" 
          onClick={() => setUserDropdownOpen(false)}
        />
      )}
      </>
  ):(
    <></>
      )}
    </>
  );
};

export default Header;